<template>
  <section class="roadmap-section" id="future-features">
    <div class="container">
      <h2>Future Features & Roadmap</h2>
      <p>
        We’re committed to expanding Passguard9000 with powerful new
        capabilities to make password management even more seamless.
      </p>
      <div class="roadmap-tree">
        <div
          v-for="(feature, index) in roadmap"
          :key="index"
          class="roadmap-item"
        >
          <div class="roadmap-content">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RoadmapSection",
  data() {
    return {
      roadmap: [
        {
          title: "Initial Launch",
          description: "Q1 2025 Launch of Passguard9000 with its core features",
        },
        {
          title: "Browser Extension",
          description:
            "Seamlessly insert credentials into websites with browser extensions. No more toggling between apps.",
        },
        {
          title: "Custom Storage Options",
          description:
            "Choose where to store your database—USB drives, external hard drives, and more.",
        },
        {
          title: "Android & iOS Apps",
          description:
            "Access your passwords on-the-go with native mobile applications.",
        },
        {
          title: "Automated Backups",
          description:
            "Set automatic local backups to ensure your credentials are never lost.",
        },
      ],
    };
  },
};
</script>

<style scoped>
@import "@/styles/components/Roadmap.scss";
</style>
